function updateProductBlocks(detail) {
  const productBlocks = document.querySelectorAll('[data-product-block]');

  productBlocks.forEach(block => {
    const originalPriceBlock = block.querySelector('[data-original-price]');
    const comparePriceBlock = block.querySelector('[data-compare-price]');
    const saveBadgePrice = block.querySelector('[data-save-price]');
    const saveBadgeBlock = block.querySelector('[data-save-badge]');
    const pointsAmount = document.querySelector('[data-points-amount]');

    if (!originalPriceBlock) return;

    const price = detail.originalPrice / 100;
    const comparePrice = detail.compareAtPrice / 100;

    if (pointsAmount) {
      pointsAmount.textContent = Math.floor(price);
    }

    originalPriceBlock.textContent = `$${price.toFixed(2)}`;

    if (comparePrice > price) {
      comparePriceBlock.textContent = `$${comparePrice.toFixed(2)}`;
      comparePriceBlock.style.display = 'block'
      saveBadgePrice.textContent = `$${(comparePrice - price).toFixed(2)}`;
         saveBadgeBlock.style.display = 'block'
    } else {
      comparePriceBlock.style.display = 'none'
      saveBadgeBlock.style.display = 'none'
    }
  });
}

document.addEventListener('ChangeVariant', (event) => {
  updateProductBlocks(event.detail);
});

document.addEventListener('click', (event) => {
  if (event.target.matches('[data-dropdown-item]')) {
    let selectedItem = $(".t4s-swatch__item.shujja-swatch__item.is--selected");

    let productSale = selectedItem.attr("data-sale-show");
    let originalPrice = selectedItem.attr("data-original-price");
    let compareAtPrice = selectedItem.attr("data-compare-price");

    document.dispatchEvent(new CustomEvent('ChangeVariant', {
      detail: {
        originalPrice: originalPrice,
        compareAtPrice: compareAtPrice,
        productSale: productSale
      }
    }));


    const defaultDetail = {
      originalPrice: originalPrice,
      compareAtPrice: compareAtPrice,
      productSale: productSale
    }
    setTimeout(() => {
      updateProductBlocks(defaultDetail);
    }, 1000)
  }
});


